// pdf.js is large and only the slides item needs it, so it is loaded when the
// first PDF opens, not with the app. A failed load (no connection and not yet
// cached) is not remembered, so the next PDF tries again.
type PdfJs = typeof import("pdfjs-dist");

let loading: Promise<PdfJs> | null = null;

export function loadPdfjs(): Promise<PdfJs> {
  if (!loading) {
    loading = import("pdfjs-dist")
      .then((pdfjs) => {
        pdfjs.GlobalWorkerOptions.workerPort = new Worker(
          new URL("pdfjs-dist/build/pdf.worker.min.js", import.meta.url)
        );
        return pdfjs;
      })
      .catch((error) => {
        loading = null;
        throw error;
      });
  }
  return loading;
}
